export default function LoadingState({ message = 'Cargando…', overlay = false }) {
  const body = (
    <>
      <span className="analytics-loading-spinner" aria-hidden="true" />
      <p className="analytics-loading-msg">{message}</p>
    </>
  );
  if (overlay) {
    return (
      <div
        className="analytics-loading-overlay"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        {body}
      </div>
    );
  }
  return (
    <div className="analytics-loading-inline" role="status" aria-live="polite">
      {body}
    </div>
  );
}
